module.exports = __webpack_public_path__ + "assets/Assault.cf6350f7.svg";